<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/station_collect/getLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="站点名称" class="lx-search-item"></Input>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="showMap=true">地图</Button>
        </FormItem>
      </template>
    </pageTable>

    <div>
      <Modal
              v-model="verifyForm.isShow"
              title="审核"
              :loading="verifyForm.isLoading"
              @on-ok="doVerify"
              @on-cancel="verifyForm.isShow=false">
        <Form ref="verifyForm" :label-width="100" :model="verifyForm">
          <FormItem label="是否有效" prop="is_valid">
            <RadioGroup v-model="verifyForm.is_valid">
              <Radio label="有效" value="1"></Radio>
              <Radio label="无效" value="-1"></Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="奖励金额" prop="amount">
            <Input v-model="verifyForm.amount" placeholder=""></Input>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model="verifyForm.remark" placeholder=""></Input>
          </FormItem>
        </Form>
      </Modal>
    </div>

    <div v-if="showMap">
      <Modal v-model="showMap" fullscreen title="地图">
        <stationCollectMap></stationCollectMap>
      </Modal>

    </div>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stationCollectMap from "./stationCollectMap";
  export default {
    name: "stationCollect",
    components:{pageTable,stationCollectMap},
    data() {
      return {
        searchData: {
          gas_name: '',
        },
        showMap:false,
        station_types:[],
        tableColumn: [
          {title: '司机姓名',key: 'name',align: "center"},
          {title: '司机电话',key: 'mobile',align: "center"},
          {title: '收款二维码',align: "center",render:(h,params)=>{
              let images = [],imagesContent=[];
              images.push(params.row.payment_code)
              imagesContent.push(h('img',{attrs:{src:params.row.payment_code},style:{width:"30px",height:'30px'}}))
              if (images.length<=0) return h('p','');
              return h('viewer',{
                props:{images:images},
              },imagesContent)
            }},
          {title: '站点类型',key: 'station_type_name',align: "center"},
          {title: '站点联系人',key: 'name',align: "center"},
          {title: '站点电话',key: 'mobile',align: "center"},
          {title: '省',key: 'province_name',align: "center"},
          {title: '市',key: 'city_name',align: "center"},
          {title: '区',key: 'area_name',align: "center"},
          {title: '地址',key: 'address',align: "center"},
          {title: '上传时间',key: 'ctime',align: "center"},
          {title: '操作',render:(h,params)=>{
            if (params.row.status===0){
              return h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.showVerify(params.row.id)}}},'审核')
            }else{
              return h('div',[
                h('p',params.row.status===1 ? '有效' : '无效'),
                h('p',params.row.verify_remark),
              ])
            }
            }},
        ],
        tableData: [],
        verifyForm:{
          isShow:false,
          id:0,
          isLoading:false,
          is_valid:'',
          amount:'',
          remark:'',
        }
      }
    },
    methods: {
      showVerify(id){
        this.verifyForm.id = id
        this.verifyForm.isShow = true
      },
      async doVerify(){
        this.verifyForm.isLoading=true
        this.$commonFun.postProxy('admin/station_collect/doVerify',this.verifyForm).then(res=>{
          this.verifyForm.isLoading=false
          this.$commonFun.dealApiResult(res,()=>{
            this.$commonFun.successTip(res.msg,()=>{
              this.$refs.table.getLists();
            })
          })
        })
      },
    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>
